import React from "react";
import { Route, Routes } from "react-router";
import AdminStaff from "../containers/admin/user";
import AddUser from "../containers/admin/user/addUser";
import EditUser from "../containers/admin/user/editUser";
import AllOeders from "../containers/admin/orders";
import AddNewOrder from "../containers/admin/orders/AddNewOrder";
import Products from "../containers/admin/products";
import AddProduct from "../containers/admin/products/addProduct";
import EditProduct from "../containers/admin/products/editProduct";
import Warehouse from "../containers/admin/warehouse";
import Dashboard from "../containers/admin";
import NdrOrders from "../containers/admin/orders/NdrOrders";
import UsersPage from "../containers/admin/orders/UserOrders";
import UserOrders from "../containers/admin/orders/UserOrders/UserPage";
import ReportSection from "../containers/admin/orders/ReportSection";
import CodSection from "../containers/admin/orders/ReportSection/CodSection";
import PrepaidSection from "../containers/admin/orders/ReportSection/PrepaidSection";
import SalesSheet from "../containers/admin/orders/ReportSection/SalesSheet";
import RtoReturns from "../containers/admin/RtoStatus/RejectRto";
import PaymentVerification from "../containers/admin/orders/AddNewOrder/PaymentVerfication";

const adminRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/user" element={<AdminStaff />} />
        <Route path="/user/add-user" element={<AddUser />} />
        <Route path="/user/edit-user/:id" element={<EditUser />} />
        <Route path="/reportsection" element={<ReportSection />} />
        <Route path="/payment-verification" element={<PaymentVerification />} />
        <Route path="/reportsectioncod" element={<CodSection />} />
        <Route path="/reportsectionprepaid" element={<PrepaidSection />} />
        <Route path="/reportsectionsales" element={<SalesSheet />} />
        <Route path="/warehouse" element={<Warehouse />} />
        <Route path="/userorders" element={<UsersPage />} />
        <Route path="/users/:userId/orders" element={<UserOrders />} />
        <Route path="/orders" element={<AllOeders />} />
        <Route path="/orders/create-order" element={<AddNewOrder />} />
        <Route path="/ndrorders" element={<NdrOrders />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/add" element={<AddProduct />} />
        <Route path="/products/edit-product/:id" element={<EditProduct />} />
        <Route path="/admin/returns" element={<RtoReturns />} />
      </Routes>
    </div>
  );
};

export default adminRoutes;
